import { connect } from 'react-redux';
import { flow, isEmpty } from 'lodash';

import container from 'src/ServiceContainer';
import { ProductMix, ValueProps, FunctionProps } from './ProductMix';
import { requestViewDefn, receiveViewDefn, receiveError } from './ProductMix.slice';
import { getLocalConfig, updateGroupSortViaLocal } from 'src/components/Subheader/Favorites/Favorites.utils';
import type { ProductMixOwnProps } from 'configuration-schemas/ownProps';
import { AppState, AppThunkDispatch } from 'src/store';
import { isViewDefnLoaded, TenantConfigViewData } from 'src/dao/tenantConfigClient';
import { getDataFromCache } from 'src/services/pivotServiceCache';
import { ComponentErrorType } from 'src/components/ErrorBoundary/ErrorBoundary.slice';
import { ConfDefnComponentType } from 'configuration-schemas/confdefnComponents';
import { isDataLoaded } from 'src/services/pivotServiceCache';
import { AppType } from 'configuration-schemas/general';
import { makePrintSensitive } from 'src/components/higherOrder/Print/PrintSenstive';
import { zProductMixViewDefn } from 'configuration-schemas/viewdefns/viewdefn';

function mapStateToProps(state: AppState, ownProps: ProductMixOwnProps): ValueProps {
  const { title, defns } = ownProps;
  const viewState = state.pages.hindsighting.productMix;
  const { viewDefnState, viewDataState, viewDefn } = viewState;
  const loaded = isViewDefnLoaded(viewDefnState) && isDataLoaded(viewState.viewDataState);
  const treeData = getDataFromCache(viewState)?.tree || [];
  const data = !isEmpty(treeData) ? treeData[0].children : treeData;
  const totals = treeData[0];

  return {
    title,
    groupByViewDefnStr: defns.subheader.groupBy,
    loaded,
    pieChartView: viewDefn?.view[0],
    barChartView: viewDefn?.view[1],
    data,
    totals,
    groupBy: state.subheader.groupBy,
    flowStatus: state.subheader.flowStatus,
    viewDefn: viewDefn || ({} as TenantConfigViewData),
    viewDataState,
  };
}

function dispatchToProps(dispatch: AppThunkDispatch, { defns }: ProductMixOwnProps): FunctionProps {
  return {
    onShowView() {
      dispatch(requestViewDefn());
      container.tenantConfigClient
        .getTenantViewDefnsWithFavorites({
          defnIds: defns.view,
          appName: AppType.Assortment,
          validationSchemas: [zProductMixViewDefn],
        })
        .then((resp) => {
          getLocalConfig(defns.view[0], (resp as any)[defns.view.length], dispatch);
          dispatch(receiveViewDefn(resp[0]));
        })
        .then(() => {
          updateGroupSortViaLocal(defns.view[0], dispatch);
        })
        .catch((error) =>
          dispatch(
            receiveError({
              type: ComponentErrorType.config,
              message: (error as Error)?.message,
              name: ConfDefnComponentType.productMix,
              stack: (error as Error)?.stack,
              issues: error,
              defnId: error.defnId,
            }),
          ),
        );
    },
  };
}

const sensitiveView = flow(() => ProductMix, makePrintSensitive)();

export default connect(mapStateToProps, dispatchToProps)(sensitiveView);
